<template>
  <div id="approvaDia">
    <el-dialog
      title="审批弹窗"
      :visible.sync="approvalVisible"
      width="430"
      :before-close="() => { $emit('approvalSwitch', false) }"
    >
      <div v-if="approvalType !== 2">
        <div :class="boxStyle[FApprovalStatus]">
          <span style="color:#79788B;">
            当前订单状态：
          </span>
          <i v-if="FApprovalStatus === 2" class="el-icon-circle-close" style="margin-right:7px;" />
          <span>{{ approvalStatus[FApprovalStatus] }}</span>
          <div v-if="FApprovalStatus === 2">
            拒绝原因：{{ showFAbstract }}
          </div>
        </div>
        <div class="steps-box">
          <div class="steps-content" style="width: 87%;">
            <div class="process-time" style="justify-content: center;">
              <!-- width:${100 / FApprovalList.length}% -->
              <div style="flex-basis: 145px;" />
              <div v-for="(t,i) in FApprovalList" :key="i" style="flex-basis: 145px;">{{ t.FApprovalTime }}</div>
            </div>
            <div>
              <el-steps space="145px" :active="0" style="flex-direction: column;">
                <div style="display:flex;justify-content: center;">
                  <el-step status="success" title="已通过" description="发起账号" />
                  <el-step
                    v-for="(t,i) in FApprovalList"
                    :key="i"
                    :status="(t.FIsCurrentAppr && t.FStatus === 0) ? 'wait' : stepsStatus[t.FStatus]"
                    :title="(t.FIsCurrentAppr && t.FStatus === 0) ? '审批中' : stepsText[t.FStatus]"
                    :description="description[t.FApprovalStep - 1]"
                    :class="t.FStatus === 3 ? 'positon-text' : ''"
                  />
                </div>

                <div class="process-name" style="justify-content: center;">
                  <div style="flex-basis: 145px;">
                    {{ FApplyAcount }}
                  </div>
                  <div v-for="(t,i) in FApprovalList" :key="i" style="flex-basis: 145px;">{{ t.FApprovalName }}</div>
                </div>
              </el-steps>
            </div>

          </div>
        </div>
      </div>
      <div v-if="approvalType === 2" style="text-align: center;padding: 80px 100px 0;">
        <div>
          <svg-icon style="font-size: 50px;" icon-class="approval" />
        </div>
        <div
          style="height: 50px;
                line-height: 50px;
                font-size: 18px;
          "
        >
          是否对发起账号：
        </div>
        <div style="font-size:18px;color:#ea232d;font-weight: 600;line-height: 35px;">
          {{ selectUserName }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span v-if="approvalType === 1">
          <el-button class="close_btn" @click="() => { $emit('approvalSwitch', false) }">关 闭</el-button>
        </span>
        <span v-if="approvalType !== 1">
          <el-button class="close_btn" @click="refuse">拒 绝</el-button>
          <el-button class="confirm_btn" type="primary" @click="confirm">同 意</el-button>
        </span>
      </span>
    </el-dialog>
    <div id="refuse-box">
      <el-dialog
        title="拒绝原因"
        :visible.sync="refuseVisible"
        width="430"
        :before-close="handleClose"
      >
        <el-input
          v-model="FAbstract"
          type="textarea"
          :rows="2"
          placeholder="请输入拒绝原因（50字以内）"
          maxlength="50"
          show-word-limit
          resize="none"
          :autosize="{ minRows: 3, maxRows: 3 }"
        />
        <span slot="footer" class="dialog-footer">
          <el-button class="close_btn" @click="handleClose">取 消</el-button>
          <el-button class="confirm_btn" type="primary" @click="cfmRefuse">确 认</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import service from '@/utils/request'
export default {
  components: {
  },
  props: {
    approvalVisible: {
      type: [Boolean]
    },
    selectId: {
      type: [Number, String],
      default: null
    },
    selectUserName: {
      type: [String],
      default: null
    },
    approvalType: {
      type: [Number],
      default: null
    },
    selectOrderAmount: {
      type: [Number],
      default: null
    },
    selectOrderFid: {
      type: [Number, String],
      default: () => null
    }
  },
  data() {
    return {
      cfmVisible: false,
      lastApproval: null,
      showFAbstract: '',
      FAbstract: '',
      refuseVisible: false,
      FNextStep: '',
      FApprovalList: [],
      FApplyAcount: '',
      FApprovalStatus: null,
      boxStyle: [
        'approvalBody',
        'approvalBody underReview',
        'approvalBody refuse',
        'approvalBody adopt'
      ],
      stepsStatus: [
        'process',
        'error',
        'success',
        'error'
      ],
      stepsText: {
        0: '待审批',
        1: '已拒绝',
        2: '已通过',
        3: ' ',
        '-1': '已通过'
      },
      approvalStatus: [
        '待审批',
        '审批中',
        '已拒绝',
        '已通过'
      ],
      description: [
        '一级审批',
        '二级审批',
        '三级审批',
        '四级审批',
        '五极审批'
      ]
    }
  },
  watch: {
    approvalVisible(val) {
      if (val && this.selectId && !this.selectUserName) {
        const loadingObj = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.5)',
          target: document.querySelector('.submit-test-dialog')
        })
        service({
          url: '/mall/mallmanage/billapprovalinfo/detail',
          method: 'post',
          params: {
            FInfoID: this.selectId
          }
        })
          .then(res => {
            const { FApplyAcount, FApprovalList, FApprovalStatus, FNextStep } = res.data
            this.FApprovalStatus = FApprovalStatus
            this.FApplyAcount = FApplyAcount
            let isRefuse = false
            FApprovalList.forEach(t => {
              if (isRefuse) {
                t.FStatus = 3
              }
              if (t.FStatus === 1) {
                isRefuse = true
              }
            })
            this.FApprovalList = FApprovalList
            this.FNextStep = FNextStep
            if (FApprovalStatus === 2) {
              this.FApprovalList.forEach(item => {
                if (item.FStatus === 1) {
                  this.showFAbstract = item.FAbstract
                }
              })
            }
            loadingObj.close()
          })
          .catch(() => {
            loadingObj.close()
          })
      }
    }
  },
  methods: {
    cfmSwitch() {
      this.cfmVisible = false
    },
    cfmRefuse() {
      this.approval(0)
    },
    handleClose() {
      this.FAbstract = ''
      this.refuseVisible = false
    },
    approval(FOptype) {
      const loadingObj = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.5)',
        target: document.querySelector('.submit-test-dialog')
      })
      const jsonobj = {
        FOptype,
        FInfoID: '',
        FAbstract: this.FAbstract
      }
      if (this.approvalType === 2) {
        jsonobj.FInfoID = this.selectId
      } else {
        this.FApprovalList.forEach((t, i) => {
          if (t.FIsCurrentAppr === 1) {
            if (i === this.FApprovalList.length - 1 && FOptype) {
              this.lastApproval = t
            } else {
              this.lastApproval = null
            }
            jsonobj.FInfoID = t.FInfoID
          }
        })
      }
      const data = new URLSearchParams()
      data.append('jsonobj', JSON.stringify(jsonobj))
      service({
        url: '/mall/mallmanage/billapprovalinfo/approval',
        method: 'post',
        data
      })
        .then(res => {
          if (res.result) {
            this.$parent.$parent.$parent.$refs.rightNav.comput.FWAQuanty--
            this.refuseVisible = false
            const b = !!this.lastApproval
            if (b) {
              service({
                url: '/mall/mallmanage/demandOrder/queryReceivingAddr',
                method: 'post'
              })
                .then(ress => {
                //   if (ress.data.paymentTypeList[0].availableAmount - this.selectOrderAmount > 0) {
                //     const fnoList = [{
                //       fno: this.selectOrderFid
                //     }]
                //     const data = new URLSearchParams()
                //     data.append('jsonobj', JSON.stringify({ fnoList }))
                //     service({
                //       url: '/mall/mallmanage/demandOrder/confirmOrder',
                //       method: 'post',
                //       data
                //     })
                //       .then(res => {
                //         if (res.result) {
                //           this.$message.success(res.msg)
                //         } else {
                //           this.$message.error(res.msg)
                //         }
                //       })
                //   }
                  this.$emit('approvalSwitch', b)
                  this.$emit('onSearch')
                  this.$message.success(res.msg)
                  loadingObj.close()
                  this.$router.push({
                    path: '/order/orderManagement'
                  })
                })
            } else {
              this.$emit('approvalSwitch', b)
              this.$emit('onSearch')
              this.$message.success(res.msg)
              loadingObj.close()
            }
          } else {
            this.$message.error(res.msg)
            loadingObj.close()
          }
        })
        .catch(() => {
          loadingObj.close()
        })
    },
    refuse() {
      this.refuseVisible = true
    },
    confirm() {
      this.approval(1)
    }
  }
}
</script>

<style lang="scss" scoped>
#approvaDia {
    #refuse-box {
        .confirm_btn {
            margin-left: 23px;
        }
    }
    .steps-box {
        position: relative;
        margin-top: 42px;
        // padding: 0 45px;
        height: 165px;
        .steps-content {
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .process-time {
            display: flex;
            width: 100%;
            height: 25px;
            div {
              position: relative;
              top: 6px;
              left: 12px;
              text-align: center;
              font-size: 14px;
              color: #A0A6BB;
            }
        }
        .process-name {
            display: flex;
            width: 100%;
            font-size: 16px;
            color: #595C65;
        }
    }
    .approvalBody {
        min-height: 40px;
        line-height: 40px;
        font-size: 18px;
        margin-top: 10px;
        background: rgba(255,214,165,0.2000);
        color: #FFAA47;
        text-align: center;
    }
    .underReview {
        background-color: #DEECFA;
        color: #5B9EE6;
    }
    .refuse {
        background-color: #FDE8E9;
        color: #EC212D;
    }
    .adopt {
        background-color: #DEF6E3;
        color: #5BD372;
    }
    .dialog-footer {
        .close_btn {
            border: 1px solid #EC212D;
            color: #EC212D;
        }
        .confirm_btn {
            margin-left: 128px;
        }
    }
}
</style>
<style lang="scss">
#approvaDia {
    #refuse-box {
        .el-textarea {
            max-height: 120px;
            height: 100%;
        }
        .el-textarea__inner {
            height: 100%;
        }
        .el-dialog {
            width: 531px;
            height: 257px;
        }
        .el-dialog__body {
            padding: 20px 24px;
        }
        .el-dialog__footer {
            padding-right: 30px;
            height: 56px;
            line-height: 56px;
            display: flex;
            justify-content: right;
            align-items: center;
        }
        .dialog-footer {
            height: 56px;
        }
    }
    .steps-box {
        .positon-text {
            .el-step__description {
                position: relative;
                top: 38px;
            }
        }
        .el-step__description {
            color: #81879D !important;
        }
        .is-success {
            color: #5BD372;
            border-color: #5BD372;
            .el-step__line {
                background-color: #5BD372;
            }
        }
        .is-finish {
            color: #5BD372;
            border-color: #5BD372;
            .el-step__line {
                background-color: #5BD372;
            }
        }
        .is-wait {
            color: #5B9EE6;
            .is-text {
                border-color: #5B9EE6;
            }
            .el-step__line {
                background-color: #5B9EE6;
            }
        }
        .is-process {
            color: #FFAA47;
            .is-text {
                border-color: #FFAA47;
            }
            .el-step__line {
                background-color: #FFAA47;
            }
        }
        .is-error {
            color: #EC212D;
            .is-text {
                border-color: #EC212D;
            }
            .el-step__line {
                background-color: #EC212D;
            }
        }
    }
    .el-dialog {
        position: relative;
        top: 45% !important;
        width: 1050px;
        height: 411px;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        border-radius: 10px 10px 0 0;
        text-align: center;
    }
    .el-dialog__body {
        padding: 0;
        height: 300px;
    }
    .el-dialog__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        height: 70px;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
}
</style>
